namespace $ {
	/** One connection per iframe; never grants the application a tab selector. */
	export class $shm_hitalama_extension_bridge extends $mol_object {
		@ $mol_mem
		static current() { return new this() }
		private pending = new Map< string, { resolve: ( value: any ) => void, reject: ( error: Error ) => void, timer: ReturnType< typeof setTimeout > } >()
		private origin = ''
		private session = ''
		private listening = false
		private connection?: Promise< { url: string, session: string } | null >
		private receive = ( event: MessageEvent ) => {
			if( event.source !== window.parent || ( this.origin && event.origin !== this.origin ) ) return
			const data = event.data
			if( data?.channel !== 'hitalama:bridge' ) return
			const task = this.pending.get( data.id )
			if( task ) {
				this.pending.delete( data.id ); clearTimeout( task.timer )
				if( data.error ) task.reject( new Error( data.error ) )
				else {
					if( data.result?.session ) {
						this.origin = event.origin; this.session = data.result.session
						this.event( 'fullscreen', Boolean( data.result.fullscreen ) )
						this.connected( true )
					}
					task.resolve( data.result )
				}
			}
			if( typeof data.event === 'string' ) this.event( data.scope ? data.scope + ':' + (data.owner || '') + ':' + data.event : data.event, data.value )
		}
		@ $mol_mem_key
		event( name: string, next?: any ): any { return next ?? null }
		@ $mol_mem
		connected( next?: boolean ) { return next ?? false }
		connect() {
			if( window.parent === window ) return Promise.resolve( null )
			const connection = this.connection ??= this.request( 'connect' )
			// Share the host handshake, not a wire consumer's Promise wrapper.
			// A later independent consumer must receive its own completion callback.
			return connection.then( value=> value )
		}
		request( method: string, payload: Record< string, any > = {} ): Promise< any > {
			if( !this.listening ) { window.addEventListener( 'message', this.receive ); this.listening = true }
			const id = crypto.randomUUID()
			return new Promise( ( resolve, reject ) => {
				const timer = setTimeout( () => {
					this.pending.delete( id )
					reject( new Error( 'Расширение не ответило за 15 секунд. Проверьте его подключение и разрешения.' ) )
				}, 15000 )
				this.pending.set( id, { resolve, reject, timer } )
				window.parent.postMessage( { channel: 'hitalama:bridge', id, method, session: this.session, ...payload }, this.origin || '*' )
			} )
		}
		execute( scope: string, code: string, args: any = null, world: 'USER_SCRIPT' | 'MAIN' = 'USER_SCRIPT', owner = '' ) {
			return this.request( 'execute', { scope, code, args, world, owner } )
		}
		dispose( scope: string, world: 'USER_SCRIPT' | 'MAIN' = 'USER_SCRIPT', owner = '' ) { return this.request( 'dispose', { scope, world, owner } ) }
		host( command: string, value: any ) {
			if( this.connected() ) window.parent.postMessage( { channel: 'hitalama:host', command, value }, this.origin )
		}
		destructor() {
			window.removeEventListener( 'message', this.receive )
			for( const task of this.pending.values() ) { clearTimeout( task.timer ); task.reject( new Error( 'Подключение закрыто.' ) ) }
			this.pending.clear()
			super.destructor()
		}
	}
}
